import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";
import { useTranslation } from "@/translations";

import { BulkRemsEditor } from "./BulkRemsEditor";
import { PortfolioIntegrationWorkspace } from "./PortfolioIntegrationWorkspace";
import { RemsProjectSetupQueue } from "./ProjectSetupQueue";
import { usePortfolioRemsProjects } from "./usePortfolioIntegrationProjects";

/** Manages portfolio-wide REMS configuration and project-specific setup. */
export function RemsPortfolioIntegrationPage(): React.ReactNode {
  const { t } = useTranslation();
  const projects = usePortfolioRemsProjects();

  if (projects.error) {
    return <ErrorPage error={projects.error} />;
  }
  if (projects.isLoading) {
    return <FullSizeLoader withPadding />;
  }

  return (
    <PortfolioIntegrationWorkspace
      name={t("page.integration.rems.title")}
      description={t("page.portfolio-integrations.workspace.description")}
      rows={projects.rows}
      showIntegrationStatus
      renderBulkEditor={({ rows, selectedProjectIds, onContinueToProjectSetup }) => (
        <BulkRemsEditor
          rows={rows}
          selectedProjectIds={selectedProjectIds}
          onContinueToProjectSetup={onContinueToProjectSetup}
        />
      )}
      renderProjectSetup={({ rows, selectedProjectIds }) => (
        <RemsProjectSetupQueue rows={rows} selectedProjectIds={selectedProjectIds} />
      )}
    />
  );
}
